import omit from 'ramda/es/omit';
import { useCallback, useContext, useEffect, useState } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { BudgetFilterKeys, RangeType } from '../constants';

export type RangeInputState = {
  [key in RangeType]?: number;
};

export default function useRangeInput(filterKey: BudgetFilterKeys) {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const [values, setValues] = useState<RangeInputState>(
    appliedFilters[filterKey] || {}
  );

  useEffect(() => {
    if (!appliedFilters[filterKey]) {
      setValues({});
    } else {
      setValues({ ...appliedFilters[filterKey] });
    }
  }, [appliedFilters]);

  const updateValues = useCallback(
    (rangeType: RangeType, value: number) => {
      const shouldClearFilter = value === 0;
      if (shouldClearFilter) {
        setValues(currentValues => ({
          ...omit([rangeType], currentValues)
        }));
      } else {
        setValues(currentValues => ({
          ...currentValues,
          [rangeType]: value
        }));
      }
    },
    [appliedFilters]
  );

  return { values, updateValues };
}
